/* More slated for common configuration later, interceptors etc */
import axios from 'axios'
import keycloak from './keycloak'

export const axpi = axios;
export const kc = keycloak.kc;

export function setToken(token) {
    axios.defaults.headers.common['Authorization'] =
        `Bearer ${token}`;
}

keycloak.registerInterceptor(axpi)

// axpi.interceptors.request.use(async (config) => {
//     console.warn('Axios Interceptor', config, kc)
//     if(kc.authenticated) {
        
//         await kc.updateToken(90)
//         config.headers.Authorization = `Bearer ${kc.token}`
//     }
//     return config
// }, (err) => {
//     return Promise.reject(err)
// })

export default axpi
